import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "@store/store"
import "./index.css"
import { RouterProvider } from "react-router"
import router from "./router"
import { ThemeProvider } from "@mui/material"
import theme from "./theme"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { SnackbarProvider, closeSnackbar } from "notistack"
import Button from "@mui/material/Button"
import { ReactFlowProvider } from "reactflow"
import { KeymapProvider } from "@features/keymap/KeymapContext"
import { useAtomsDevtools } from "jotai-devtools/utils"

// TODO: dependency of "jotai-immer", should be re-exported from their side or not used at all
// as we are changing how "jotai-immer" works by maniuplating its dependency
import { enableMapSet } from "immer"
enableMapSet()

const App = () => {
  useAtomsDevtools("PGM Atoms")
  return (
    <React.StrictMode>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ThemeProvider theme={theme}>
            <SnackbarProvider
              maxSnack={4}
              hideIconVariant={true}
              autoHideDuration={3000}
              action={(snackbarId) => (
                <Button variant={"contained"} onClick={() => closeSnackbar(snackbarId)}>
                  Dismiss
                </Button>
              )}
            >
              <KeymapProvider>
                <ReactFlowProvider>
                  <RouterProvider router={router} />
                </ReactFlowProvider>
              </KeymapProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </Provider>
    </React.StrictMode>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
